import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ProjectCard({ title, desc, tags, link, gitHubLink, img }) {
    return (
        <div className="project-card">
            <div className="content">
                <img src={img} alt="project image" />
                <h2>{title}</h2>
                <p>{desc}</p>
            </div>
            <div className="buttons">
                {gitHubLink && <a href={gitHubLink} target="_blank"><FontAwesomeIcon icon={faGithub} color="#EC4D28" /></a>}
                {link && <a href={link} target="_blank"><FontAwesomeIcon icon={faLink} color="white" /></a>}
            </div>
            <div className="tags">
                {tags.map((tag, idx) => (
                    <div className="tag" style={{ color: tag.color }} key={idx}>
                        <span>{tag.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ProjectCard;
